import React, { useEffect } from "react";
import * as layoutService from "../../view/layoutService";
import { useHistory } from "react-router-dom";
import { withMainLayout } from "../../view/LayoutHOCs";
import DBRetentionSection from "./DBRetentionSection"
import LogsRetentionSection from "./LogsRetentionSection"

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Logs Retention",
        redirectTo: "/logs-retention",
    }
]

function DBRetentionPage() {

    const history = useHistory();

    useEffect(() => {
        layoutService.setPageTitle('Logs Retention Period')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])

    // const initTableConfig = {
    //     selected: []
    // }
    //const [tableConfig, setTableConfig] = useState(initTableConfig);


    return (
        <>
            <div className="container-fluid mt-2">
                <div className="row">
                    <div className="col">
                        <DBRetentionSection />
                    </div>
                    <div className="col">
                        <LogsRetentionSection />
                    </div>
                </div>
            </div>
        </>
    )

}

export default withMainLayout(DBRetentionPage);